module.exports = __webpack_public_path__ + "img/04.a07a09f6.png";